<template>
  <div class="notice_search">
    <div class="notice_content content_auto">
      <!-- <h1>{{ $t('请输入您的问题') }}</h1> -->
      <div class="search_box">
        <el-input v-model="searchProblem" :placeholder="$t('在这儿搜索')" @input="searchNotice">
          <SvgIcon name="shousuo" slot="suffix"></SvgIcon>
        </el-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      searchProblem: '',
      searchTimer: '' // 搜索定时器
    }
  },
  mounted () {
    if (this.$route.query.search) {
      this.searchProblem = this.$route.query.search
    }
  },
  methods: {
    searchNotice () {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        if (this.$route.name === 'noticeDetail') {
          this.$router.push({ path: '/notice', query: { tag: 'isDetail', search: this.searchProblem } })
        }
        this.$emit('searchNotice', this.searchProblem)
      }, 1800)
    }
  }
}
</script>
<style lang="less" scoped>
.notice_search{
  background: rgba(19, 22, 37, 1);
  .notice_content{
    overflow: hidden;
    h1{
      margin-top: 40px;
      height: 42px;
      font-size: 30px;
      font-family: PingFangSC-Semibold, "PingFang SC";
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 42px;
      text-align: center;
    }
    /deep/ .search_box{
      margin: 50px auto 50px;
      width: 600px;
      .element_input_mixin(@padding: 10px 20px, @fontSize: 14px, @color: rgba(255, 255, 255, 1), @backgroundColor: rgba(255, 255, 255, 0.1), @borderRadius: 30px, @border: none);
      .el-input__suffix {
        line-height: 55px;
        width: 64px
      }
    }
  }
}
</style>
